import { memo } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from '../../components'
import { handleModal } from '../../redux/actions/modals';

const ProfileConfirmationModal = ({ onSubmitRemoveProfilePicture }) => {
    const dispatch = useDispatch();

    const modals = useSelector(state => state?.modals?.modals);

    const onHide = () => {
        dispatch(handleModal([{ "PROFILE_CONFIRMATION_MODAL": false }]));
    };

    return (
        <BzModal size='sm' show={modals['PROFILE_CONFIRMATION_MODAL']} onHide={onHide} id="TopModal" role="dialog" aria-hidden="true">
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text'>Remove Profile Picture</div>
                        </Col>                       
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-start'>
                            <div className='font-regular font-size4 color-text'>Are you sure you want to remove profile picture?</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0 justify-content-end'>
                        <Col md={10} className='d-flex align-items-center'>
                            <BzButton className='btn btn-md btn-block btn-outline me-3' onClick={onHide}>No</BzButton>
                            <BzButton className='btn btn-md btn-block btn-primary' onClick={onSubmitRemoveProfilePicture}>Yes</BzButton>                            
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    )
}
export default memo(ProfileConfirmationModal)
